/// <reference path="../jscript/tsdeclarations/addinprovider.d.ts" />
module OfficeExt {
  export enum DataServiceResultCode {
    Succeeded = 1,
    Failed = 0,
    ProxyNotReady = -1,
    PrxoyUrlEmpty = -2,
    ProxyUrlNotTrusted = -3,
    UnknownUserType = 2,
    Unauthenticated = 3,
    UserResolutionNoMailbox = 4,
    ServerBusy = 5,
  }
}
